import React, { useState } from "react";
import { Lock, Eye, EyeOff } from "lucide-react";
import toast from "react-hot-toast";
import api from "../api";

export default function Login({ onLogin }) {
  const [key, setKey] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!key.trim()) return toast.error("Masukkan admin key");
    setLoading(true);
    try {
      const res = await api.get("/admin/list_licenses", {
        headers: { "X-Admin-Key": key },
      });
      if (res.status === 200) {
        localStorage.setItem("admin_key", key);
        toast.success("Login berhasil!");
        onLogin(key);
      }
    } catch (err) {
      const msg = err.response?.data?.detail || "Admin key salah";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <Lock size={32} color="#6366f1" />
        </div>
        <h1 style={styles.title}>PIPO Admin Panel</h1>
        <p style={styles.sub}>Masukkan admin key untuk lanjut</p>
        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.inputWrap}>
            <input
              type={show ? "text" : "password"}
              placeholder="Admin Key"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              style={styles.input}
              autoFocus
            />
            <button type="button" onClick={() => setShow(!show)} style={styles.eyeBtn}>
              {show ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          <button type="submit" disabled={loading} style={styles.btn}>
            {loading ? "Memverifikasi..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 50%, #16213e 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Segoe UI', sans-serif",
  },
  card: {
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 16,
    padding: "40px 48px",
    width: 380,
    backdropFilter: "blur(10px)",
    boxShadow: "0 25px 50px rgba(0,0,0,0.5)",
    textAlign: "center",
  },
  iconWrap: {
    background: "rgba(99,102,241,0.15)",
    borderRadius: "50%",
    width: 64,
    height: 64,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 20px",
    border: "1px solid rgba(99,102,241,0.3)",
  },
  title: { color: "#fff", fontSize: 24, fontWeight: 700, margin: "0 0 8px" },
  sub: { color: "#8b9cb5", fontSize: 14, margin: "0 0 28px" },
  form: { display: "flex", flexDirection: "column", gap: 12 },
  inputWrap: { position: "relative" },
  input: {
    width: "100%",
    padding: "12px 44px 12px 16px",
    background: "rgba(255,255,255,0.07)",
    border: "1px solid rgba(255,255,255,0.15)",
    borderRadius: 8,
    color: "#fff",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
  },
  eyeBtn: {
    position: "absolute",
    right: 12,
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    color: "#8b9cb5",
    cursor: "pointer",
    padding: 0,
  },
  btn: {
    padding: "12px 0",
    background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
    border: "none",
    borderRadius: 8,
    color: "#fff",
    fontSize: 15,
    fontWeight: 600,
    cursor: "pointer",
    marginTop: 4,
  },
};
